module.exports = __webpack_public_path__ + "static/media/banner_gif.37763a1a.gif";